<template>
    <div class="itinerary-card">
        <button @click="selectItinerary">
            <figure>
                <img v-if="toursVersion" src="/img/placeholder.svg" alt="Person" />
                <SvgsTurquoisePerson v-else />
            </figure>
            <div class="site-data">
                <header class="site-header">
                    <p class="card-header">{{ itinerary.name }}</p>
                    <p class="gray-tag">My Itineraries</p>
                </header>
                <p class="site-count small-book"><span>{{ siteCount }}</span> Site<span v-if="siteCount === 0 || siteCount > 1">s</span></p>
            </div>
        </button>
    </div>
</template>

<script setup>
    const props = defineProps({
        itinerary: {
            type: Object,
            required: true,
            default: {},
        },

        toursVersion: {
            type: Boolean,
            required: false,
            default: false,
        },
    });
    const { itinerary } = toRefs(props);

    const siteCount = computed(() => {
        if (itinerary.value && itinerary.value.sites) {
            return itinerary.value.sites.length || 0;
        }
    });

    const emit = defineEmits(['itinerarySelected']);
    function selectItinerary() {
        emit('itinerarySelected', itinerary.value);
    }
    defineExpose({
        selectItinerary,
    });
</script>

<style lang="scss" scoped>
    .itinerary-card {
        button {
            display: flex;
            width: 100%;

            @media (min-width: $tablet) {
                flex-direction: column;
            }
        }

        .site-data {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
            padding: 15px;
            align-self: stretch;

            .card-header {
                display: block;
            }

            .site-count {
                margin-left: auto;
            }
        }

        @media (min-width: $tablet) {
            height: 100%;

            figure {
                position: relative;
                width: 100%;
                height: 200px;
                flex-shrink: 0;
                top: 0;
                bottom: 0;
                left: 0;
                overflow: hidden;
                background: url('/img/teal-bg.svg') center / cover no-repeat;

                svg {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
</style>
